import { Flex } from 'antd';
import styled from 'styled-components';

export const FrequencyColors = [
  {
    frequency: 'Constant',
    background: '#75a141',
    color: '#fff',
  },
  // {
  //   frequency: 'RARELY',
  //   background: '#f4f9ec',
  //   color: '#cfe3b3',
  // },
  {
    frequency: 'Frequent',
    background: '#b0d086',
    color: '#75a141',
  },
  {
    frequency: 'Regular',
    background: '#cfe3b3',
    color: '#93bc5f',
  },
  {
    frequency: 'Random',
    background: '#e6f0d7',
    color: '#b0d086',
  },
];

export const Container = styled(Flex).attrs({
  vertical: true,
  gap: 2,
})`
  position: relative;
  background: #fff;
  overflow: hidden;
  height: 100%;
`;

export const TableContainer = styled(Flex).attrs({
  vertical: true,
  flex: 0,
  gap: 1,
})`
  border: 1px solid #d9d9da;
  height: auto;
  max-height: 100%;
  overflow: auto;
  max-height: 100%;

  /* 自定义滚动条样式 */
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;

    &:hover {
      background: #a8a8a8;
    }
  }
`;

export const Cell = styled(Flex).attrs({
  align: 'center',
  justify: 'start',
  wrap: 'nowrap',
})`
  width: 120px;
  height: 52px;
  padding: 15px;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  color: #a3a5a8;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  flex-shrink: 0;
  cursor: pointer;
  ${FrequencyColors.map(
    (i) =>
      `&.${i.frequency} {
        background: ${i.background};
        color: ${i.color}
      }
    `
  )}

  &:first-child {
    position: sticky;
    left: 0;
    z-index: 12;
  }
`;

export const HeadCell = styled(Cell)`
  position: relative;
  background: #e9e9ea;
  span.title {
    word-break: break-word;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // overflow: hidden;
    width: 5rem;
  }
`;

export const MoreIcon = styled.span`
  position: absolute;
  right: 0;
  width: 1rem;
  font-size: 1rem;
  background-color: #e9e9ea;
  &:hover {
    color: #2b3d21;
  }
`;

export const SlashHeader = styled(Cell)`
  padding: 2px;
  color: #2b3d21;
  line-height: 24px;
  position: sticky;
  left: 0;
  z-index: 25;
  .text-left,
  .text-right {
    position: absolute;
    span {
      color: ${(props) => props.theme.antd.colorPrimary};
    }
  }
  .text-left {
    bottom: 6px;
    left: 4px;
  }

  .text-right {
    top: 6px;
    right: 4px;
  }
`;

export const BlankCell = styled.div`
  width: 120px;
  height: 52px;
  flex-shrink: 0;
  background: #fff;
`;

export const StickyBlankCell = styled(BlankCell)`
  position: sticky;
  right: 0;
  z-index: 12;
`;

export const AddCell = styled(Cell).attrs({
  gap: 4,
})`
  &:hover {
    color: ${(props) => props.theme.antd.colorPrimary};
  }
  &.disabled {
    cursor: not-allowed;
    &:hover {
      color: #a3a5a8;
    }
  }
`;

export const AddColumnCell = styled(AddCell)`
  background: #fff;
  border-left: none;
  height: 52px;
  flex-shrink: 0;
  align-self: flex-start;
  position: sticky;
  right: 0;
  z-index: 12;
`;

export const TableRow = styled(Flex).attrs({
  gap: 1,
})`
  min-width: max-content;
`;

export const TableHeader = styled(Flex).attrs({
  gap: 1,
})`
  min-width: max-content;
  position: sticky;
  top: 0;
  z-index: 20;
  background: #fff;
`;

export const SpinContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  min-height: 70vh;
  top: 0;
  left: 0;
  z-index: 90;
`;
